import React from 'react'
import {connect} from 'react-redux'
import {Table, Thead, Th, Tr, Td} from 'components/reactable'
import styles from './clientContracts.scss'
import {setOpenedSubmenu} from 'state/actions'
import ContractZoom from './clientContractsZoom'
import CreateContract from './clientContractCreate'
import nesProp from 'nested-property'
import NoResults from '../noResults'

import i18n from 'lib/i18n'
import moment from 'moment'
const _ = i18n('clientContracts')

const Results = ({data, zoomTo, setState, createPrev, createPrem}) => {
    const icons = {
        0: 'c-credit',
        1: 'c-life',
        2: 'c-health',
        3: 'c-home',
        4: 'c-family',
        5: 'c-automotive',
        6: 'c-workinjuries',
        7: 'c-fire',
        8: 'c-transport',
        9: 'c-misc',
    }

    const topPaginationElemR = []

    if(createPrem){
        topPaginationElemR.push(
            <input
                key={"createPremContractModalOpenerButtonKey"}
                onClick={() => {
                    setState({createPremContractModalIsOpen: true})
                    
                }}
                type="button"
                className={styles.buttonGreen}
                value={_('mandate')}
            />
        )
    }


    if (createPrev) {
        topPaginationElemR.push(
            <input
                key={"createContractModalOpenerButtonKey"}
                onClick={() => {
                    setState({createContractModalIsOpen: true})
                }}
                type="button"
                className={styles.buttonGreen}
                value={_('request')}
            />
        )
    }

    let tableData = data || []

    return (
        <div className={styles.clientsTableContainer}>
            <Table
                className={styles.table}
                itemsPerPage={10}
                filterable={[
                    "contractNumber",
                    "mainBranche",
                    "mainRisk",
                    "insuranceCompany",
                    "contractState",
                ]}
                sortable={[
                    "contractNumber",
                    "mainBranche",
                    "mainRisk",
                    "insuranceCompany",
                    "contractState",
                ]}
                defaultSort={{
                    column: 'contractState',
                    direction: 'asc',
                }}
                topPaginationElemR={
                    topPaginationElemR
                }
            >
                <Thead>
                    <Th column="claimIcon" label=""/>
                    <Th column="contractNumber">
                        <strong>{_('contractNumber')}</strong>
                    </Th>
                    <Th column="mainBranche">
                        <strong>{_('mainBranche')}</strong>
                    </Th>
                    <Th column="mainRisk">
                        <strong>{_('mainRisk')}</strong>
                    </Th>
                    <Th column="insuranceCompany">
                        <strong>{_('insuranceCompany')}</strong>
                    </Th>
                    <Th column="contractState">
                        <strong>{_('contractState')}</strong>
                    </Th>
                    <Th column="ends">
                        <strong>{_('ends')}</strong>
                    </Th>

                </Thead>
                {tableData && tableData.map((item, key) =>
                    <Tr
                        className="centered clickable"
                        key={key} onClick={() => zoomTo(item.contractId)}
                    >
                        <Td column="claimIcon">
                            <div className={styles.iconContainer}>
                                <img src={require(`resources/images/${icons[item.brancheCode]}_2x.png`)}/>
                            </div>
                        </Td>
                        <Td column="contractNumber">{item.contractNumber}</Td>
                        <Td column="mainBranche">{item.mainBranche}</Td>
                        <Td column="mainRisk">{item.mainRisk}</Td>
                        <Td column="insuranceCompany">{item.insuranceCompany}</Td>
                        <Td column="contractState">{item.contractState}</Td>
                        <Td column="ends">{(item.contractEnd || '') + ' ' + (item.contractEndDate? moment(item.contractEndDate).format('DD-MM-YYYY') : '')}</Td>
                    </Tr>
                    )
                }
            </Table>
            { (!tableData || tableData.length === 0) &&
                <NoResults type="clientContracts"/>
            }
        </div>
    )
    }

@connect(state => {
    const clientId = state.app.opened
    const clientData = state.clients.clientData[clientId]
    const contracts = clientData.contractIds.map(id => state.contracts[id])
    let actions = nesProp.get(state, "app.security.actions")
    let createPrev = actions.filter((item)=>(item.actionName === "createPrev" && item.actionAllowed === "true")).length > 0
    let createPrem = actions.filter((item)=>(item.actionName === "createPrem" && item.actionAllowed === "true")).length > 0

    return {
        allContracts: state.contracts,
        contracts,
        contractId: state.app.submenuOpened,
        subModuleZoom: state.clients.subModuleZoom,
        createContractState: state.clients.createContractState,
        clientData,
        clientId,
        createPrev,
        createPrem
    }
})
export default class ClientContracts extends React.Component {
    static propTypes = {
        dispatch: React.PropTypes.func.isRequired,
        data: React.PropTypes.array,
        contractId: React.PropTypes.string,
        clientId: React.PropTypes.string,
        createPrev: React.PropTypes.bool
    }

    constructor(props) {
        super(props)
        this.state = {createContractModalIsOpen: false, createPremContractModalIsOpen: false}
    }

    render() {
        const {allContracts, contracts, contractId, dispatch, subModuleZoom, clientData,
            clientId, createContractState} = this.props
        const {createContractModalIsOpen, createPremContractModalIsOpen} = this.state

        let contract = contractId && allContracts[contractId]
        const {createPrev, createPrem} = this.props

        if (!contract && subModuleZoom) {
            // TODO - rewrite this solution for pass the contract number
            // this is a horrible solution, not sure the first key is the contract number
            const key = Object.keys(subModuleZoom)[0]

            if (key) {
                const value = subModuleZoom[key]
                contract = contracts.find(c => c[key] === value)
            }

        }

        return (
            <div>
                <div className={styles.moduleSection}>
                    {!contract ?
                        <Results
                            {...this.props}
                            createPrev={createPrev}
                            createPrem={createPrem}
                            data={contracts || []}
                            zoomTo={contractId => dispatch(setOpenedSubmenu(contractId))}
                            setState={(paramForSetState)=>(this.setState(paramForSetState))}
                        />
                    :
                        <div className={styles.clientContractZoomContainer}>
                            <ContractZoom
                                contract={contract}
                                clientData={clientData}
                                contractId={String(contractId)}
                            />
                        </div>
                    }
                </div>

                <CreateContract
                    modalIsOpen={createContractModalIsOpen}
                    contract={{
                        contractId: '',
                        contractNumber: '',
                        error: '0', //  0 = No error / 1 = Error creating contract
                        errorString: 'This is the error string',
                    }}
                    isPrem= {false}
                    closeModal={()=>(this.setState({createContractModalIsOpen: false}))}
                    clientId={clientId}
                    policyHolder={nesProp.get(clientData, "main.name") || ""}
                />

                <CreateContract
                    modalIsOpen={createPremContractModalIsOpen}
                    contract={{
                        contractId: '',
                        contractNumber: '',
                        error: '0', //  0 = No error / 1 = Error creating contract
                        errorString: 'This is the error string',
                    }}
                    isPrem= {true}
                    closeModal={()=>(this.setState({createPremContractModalIsOpen: false}))}
                    clientId={clientId}
                    policyHolder={nesProp.get(clientData, "main.name") || ""}
                />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/clients/clientContracts.jsx